import React, { Component } from 'react';
import NavBar from '../components/NavBar';
import HeroSliderThree from '../components/HeroSliderThree';
import VideoCta from '../components/VideoCta';
// import ProjectSliderTwo from '../components/ProjectSliderTwo';
import ServiceTab from '../components/ServiceTab';
import TestimonialSlider from '../components/TestimonialSlider';
import EquipmentRental from '../components/EquipmentRental';
import JobsSection from '../components/JobsSection';

import Footer from '../components/Footer';
import MobileMenu from '../components/MobileMenu';

class HomeTwo extends Component {
    render() {

        return (
            <div>

                {/* Navigation bar */}
                <NavBar />

                {/* Hero slider */}
                <HeroSliderThree />

                {/* Video CTA */}
                <VideoCta />

                {/* Project Slider */}
                {/* <ProjectSliderTwo/> */}

                {/* Service Tab */}
                <ServiceTab />

                {/* Equipment Rental */}
                <EquipmentRental background="grey-bg" />

                {/* Testimonial Slider */}
                <TestimonialSlider />

                {/* Team job */}
                {/* <TeamJob/> */}

                {/* Brand logo */}
                {/* <BrandLogoSlider background="grey-bg" /> */}

                {/* Jobs Section */}
                <JobsSection />

                {/* Footer */}
                <Footer />

                {/* Mobile Menu */}
                <MobileMenu />

            </div>
        )
    }
}


export default HomeTwo;